export default function App() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.99609 16.7873H10.9978'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.5013 15.8486L15.6249 17.725L14.5 16.5992'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        x='2.99609'
        y='3.28125'
        width='18.0075'
        height='18.0075'
        rx='3'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.9994 13.2854H6.99609'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        x='6.99609'
        y='7.2832'
        width='3.50146'
        height='3.00125'
        rx='0.5'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
